module.exports = __webpack_public_path__ + "static/media/and_scr_simple.1369a215.png";